import React, { useEffect, useState } from "react";
import { useSortBy, useTable } from "react-table";
import { Tooltip } from "../utils/Tooltip";

import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { globalTimeFormat } from "../../../../../components/Security";

function SetInfoMain(header, _cell, editHandleClick, deleteHandleClick) {
	const data = _cell.render("Cell").props.row.original;
	const tdValue = _cell.render("Cell").props.value;

	if (header === "") {
		return (
			<td>
				<div
					className="row"
					style={{ alignItems: "center", justifyContent: "center" }}
				>
					<Tooltip text="Update">
						<div
							style={{ padding: "0 5px" }}
							onClick={() => editHandleClick(data)}
						>
							<ModeEditIcon />
						</div>
					</Tooltip>
					{deleteHandleClick ? (
						<Tooltip text="Delete">
							<div
								style={{ padding: "0 5px" }}
								onClick={() => deleteHandleClick(data)}
							>
								<DeleteForeverIcon />
							</div>
						</Tooltip>
					) : (
						<></>
					)}
				</div>
			</td>
		);
	}

	if (header === "Benefits List") {
		return (
			<td>
				{tdValue.map((value, index) => (
					<div style={{ margin: "20px 0" }}>
						{" "}
						{`${value.name ? value.name : "No description"
							}: ${value.amount.toLocaleString("en-US", {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							})}`}{" "}
					</div>
				))}
			</td>
		);
	}

	if (header === "Other Cash Advance List") {
		return (
			<td>
				{tdValue.map((value, index) => (
					<div style={{ margin: "20px 0" }}>
						{" "}
						{`${value.description ? value.description : "No description"
							}: ${value.defaultDeduction.toLocaleString("en-US", {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							})}`}{" "}
					</div>
				))}
			</td>
		);
	}
	if (header === "Company Loans List") {
		return (
			<td>
				{tdValue.map((value, index) => (
					<div style={{ margin: "20px 0" }}>
						{" "}
						{`${value.description ? value.description : "No description"
							}: ${value.defaultDeduction.toLocaleString("en-US", {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							})}`}{" "}
					</div>
				))}
			</td>
		);
	}

	if (header === "Status") {
		if (data.isActive) {
			return <td>Active</td>;
		} else {
			return <td>InActive</td>;
		}
	}

	if (header === "Approved?") {
		return (
			<td>
				<input
					type="checkbox"
					id="overtime-allowance"
					className="checkbox"
					name=""
					checked={data.isApproved}
					disabled={true}
				/>
			</td>
		);
	}

	if (header === "Enabled?") {
		return (
			<td>
				<input
					type="checkbox"
					id="overtime-allowance"
					className="checkbox"
					name=""
					checked={data.idEnabled}
					disabled={true}
				/>
			</td>
		);
	}

	if (
		header === "Time From" ||
		header === "Time To" ||
		header === "Time In" ||
		header === "Time Out"
	) {
		const time = _cell.render("Cell").props.value;
		if (!time) {
			return <td></td>;
		}

		let timeParts;
		let formattedTime;

		if (globalTimeFormat === "Standard Time") {
			const timeSplit = time.split("T");
			if (timeSplit.length > 1) {
				timeParts = timeSplit[1].substr(0, 5).split(":");
			} else {
				timeParts = [];
			}
			let hours = parseInt(timeParts[0], 10);
			const minutes = timeParts[1];

			// Convert 24-hour format to 12-hour format and determine AM or PM
			const amPm = hours >= 12 ? "PM" : "AM";
			hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

			formattedTime = `${hours}:${minutes} ${amPm}`;
		} else if (globalTimeFormat === "Military Time") {
			const timeSplit = time.split("T");
			if (timeSplit.length > 1) {
				timeParts = timeSplit[1].substr(0, 5).split(":");
			} else {
				timeParts = [];
			}
			let hours = parseInt(timeParts[0], 10);
			const minutes = timeParts[1];

			formattedTime = `${hours}:${minutes}`;
		}

		return <td>{formattedTime}</td>;
	}

	if (
		header === "Date" ||
		header === "Date From" ||
		header === "Date To" ||
		header === "Date Processed" ||
		header === "Request Date" ||
		header === "Date Requested"
	) {
		const date = new Date(_cell.render("Cell").props.value);
		if (!date) {
			return <td></td>;
		}

		const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
		const dd = date.getDate();
		const yyyy = date.getFullYear();

		const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

		return <td>{formattedDateFrom}</td>;
	}

	//Double type data
	if (
		header === "Over Percentage" ||
		header === "Deduction" ||
		header === "Salary" ||
		header === "Employee" ||
		header === "Employer" ||
		header === "Range From" ||
		header === "Range To" ||
		header === "Monthly Salary" ||
		header === "SSS ER" ||
		header === "SSS EE" ||
		header === "SSS Total" ||
		header === "ECER" ||
		header === "Total Contribution ER" ||
		header === "Total Contribution EE" ||
		header === "Total Contribution Total" ||
		header === "SE Total Contribution" ||
		header === "Salary Range From" ||
		header === "Salary Range To" ||
		header === "Total Monthly Premium" ||
		header === "Percentage" ||
		header === "Amount" ||
		header === "Total Loan" ||
		header === "Total Balance" ||
		header === "Default Deduction" ||
		header === "Allowance" ||
		header === "Total Hours" ||
		header === "Total Days" ||
		header === "Daily Salary" ||
		header === "Benefits" ||
		header === "Allowance" ||
		header === "Cash Advance" ||
		header === "Salary Advance" ||
		header === "Other Cash Advance" ||
		header === "Company Loans" ||
		header === "Total Basic" ||
		header === "Rate" ||
		header === "Hourly Rate" ||
		header === "Hours OT Regular" ||
		header === "Total OT Regular" ||
		header === "Hours OT Exceeded" ||
		header === "Total OT Exceeded" ||
		header === "Hours OT Restday" ||
		header === "Total OT Restday" ||
		header === "Hours Holiday Special" ||
		header === "Total Holiday Special" ||
		header === "Hours Holiday Regular" ||
		header === "Total Holiday Regular" ||
		header === "Hours Restday Holiday Special" ||
		header === "Total Restday Holiday Special" ||
		header === "Hours Restday Holiday Regular" ||
		header === "Total Restday Holiday Regular" ||
		header === "Additions" ||
		header === "SSS" ||
		header === "Pagibig" ||
		header === "Philhealth" ||
		header === "SSS Loan" ||
		header === "SSS Calamity Loan" ||
		header === "SSS Emergency Loan" ||
		header === "Pagibig Loan" ||
		header === "Pagibig Calamity Loan" ||
		header === "Tax" ||
		header === "Total Taxable Addition" ||
		header === "Total Non-Taxable Addition" ||
		header === "Deductions" ||
		header === "Adjustments" ||
		header === "Partial Salary Deduction" ||
		header === "Total Net Pay" ||
		header === "Total Gross Pay" ||
		header === "Days Absent" ||
		header === "Absent/s" ||
		header === "Days Leave" ||
		header === "Leave/s" ||
		header === "Hours Exceeded" ||
		header === "Total Exceeded" ||
		header === "Hours Undertime" ||
		header === "Undertime" ||
		header === "Hours Late" ||
		header === "Late" ||
		header === "Night Diff" ||
		header === "OT Regular" ||
		header === "OT Restday" ||
		header === "Holiday Special" ||
		header === "Holiday Regular" ||
		header === "Restday Holiday Special" ||
		header === "Restday Holiday Regular" ||
		header === "Total Absents" ||
		header === "Total Late" ||
		header === "Total Undertime" ||
		header === "Total Leaves" ||
		header === "Total Night Diff" ||
		header === "Total Exceed" ||
		header === "Exceed" ||
		header === "Total Days Regular Holidays" ||
		header === "Total Regular Holiday Worked" ||
		header === "Total Regular Holidays" ||
		header === "Total Days Special Non-Working Holidays" ||
		header === "Total Special Non-Working Holidays"
	) {
		const value = _cell.render("Cell").props.value;

		// Check if value is a number
		const isNumber = typeof value === "number";

		const numberWithCommasAndDecimal = (number) => {
			return number.toLocaleString("en-US", {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		};

		if (!isNumber) {
			return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
		}

		const formattedNumber = numberWithCommasAndDecimal(value);

		return <td>{formattedNumber}</td>;
	}

	return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}

export function CreateTable({
	dataList = [],
	dataHeader = [],
	dataAccessor = [],
	currentPage,
	setCurrentPage,
	editHandleClick,
	deleteHandleClick,
}) {
	const itemsPerPage = 10;

	const columns = React.useMemo(
		() =>
			dataHeader.map((header, index) => ({
				Header: header,
				accessor: dataAccessor[index],
			})),
		[dataHeader, dataAccessor]
	);

	const [sortHeaderValue, setSortHeaderValue] = useState({
		id: "",
		desc: false,
		isDefault: true,
	});

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows,
		prepareRow,
		setSortBy,
	} = useTable(
		{
			columns,
			data: dataList,
			initialState: {
				sortBy: sortHeaderValue.isDefault
					? [] // No sorting if it's default
					: [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
			},
		},
		useSortBy
	);

	const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
	const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
	const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

	const totalPages = Math.ceil(rows.length / itemsPerPage);
	const isLastPage = currentPage === totalPages;

	const paginate = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setCurrentPage(pageNumber);
		}
	};

	//Sorting Feature
	const sortState = [
		{ id: 0, state: "default", textValue: "" },
		{ id: 1, state: "ascending", textValue: "↑" },
		{ id: 2, state: "descending", textValue: "↓" },
	];

	const headerClick = (column) => {
		if (sortHeaderValue.id !== column.id) {
			// New column selected, start with ascending order
			setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
			setSortBy([{ id: column.id, desc: false }]);
		} else {
			// Toggle between sorting states (default -> ascending -> descending -> default)
			if (sortHeaderValue.isDefault) {
				setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
				setSortBy([{ id: column.id, desc: false }]);
			} else if (!sortHeaderValue.desc) {
				setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
				setSortBy([{ id: column.id, desc: true }]);
			} else {
				setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
				setSortBy([]); // Clear sorting
			}
		}
	};

	// Ensure sorting is reapplied on dataList reload
	useEffect(() => {
		if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
			setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
		}
	}, [dataList, setSortBy, sortHeaderValue]);

	return (
		<>
			<table {...getTableProps()} className='border-collapse'>
				<thead>
					{headerGroups.map((headerGroup) => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => (
								<th
									{...column.getHeaderProps()}
									onClick={() => headerClick(column)}
									className="sortable-header"
								>
									{`${column.render("Header")} ${sortHeaderValue.id === column.id
										? sortState[
											sortHeaderValue.isDefault
												? 0
												: sortHeaderValue.desc
													? 2
													: 1
										].textValue
										: ""
										}`}
								</th>
							))}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{dataList.length <= 0 && (
						<tr>
							<td colSpan={columns.length} style={{ textAlign: "center" }}>
								No data to display
							</td>
						</tr>
					)}
					{currentItems.map((row) => {
						prepareRow(row);
						return (
							<tr key={row.original.id} {...row.getRowProps()}>
								{row.cells.map((cell) =>
									SetInfoMain(
										cell.render("Cell").props.column.Header,
										cell,
										editHandleClick,
										deleteHandleClick
									)
								)}
							</tr>
						);
					})}
				</tbody>
			</table>
			{rows.length > itemsPerPage ? (
				<>
					<div
						className="table-page row"
						style={{
							alignItems: "center",
							justifyContent: "end",
							padding: "20px 0 0 0",
						}}
					>
						<button
							className="prev row"
							onClick={() => paginate(1)}
							disabled={currentPage === 1}
							style={{
								visibility: currentPage === 1 ? "hidden" : "visible",
								marginRight: "5px",
								height: "26px",
							}}
						>
							&lt;&lt;
						</button>
						<button
							className="prev row"
							onClick={() => paginate(currentPage - 1)}
							disabled={currentPage === 1}
							style={{
								visibility: currentPage === 1 ? "hidden" : "visible",
								marginRight: "5px",
								height: "26px",
							}}
						>
							<NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
						</button>
						<button
							className="next row"
							onClick={() => paginate(currentPage + 1)}
							disabled={indexOfLastItem >= rows.length}
							style={{
								visibility:
									rows.length > itemsPerPage && !isLastPage
										? "visible"
										: "hidden",
								marginRight: "5px",
								height: "26px",
							}}
						>
							NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
						</button>
						<button
							className="next row"
							onClick={() => paginate(totalPages)}
							disabled={indexOfLastItem >= rows.length}
							style={{
								visibility:
									rows.length > itemsPerPage && !isLastPage
										? "visible"
										: "hidden",
								height: "26px",
							}}
						>
							&gt;&gt;
						</button>
					</div>
					<div
						className="table-page row"
						style={{
							alignItems: "center",
							justifyContent: "center",
							padding: "20px 0 0 0",
						}}
					>
						{`${currentPage}/${totalPages}`}
					</div>
				</>
			) : (
				<></>
			)}
		</>
	);
}